<template>
    <div>
    <div class="loading" v-if="loading">
        <mo-loader :loading="loading"></mo-loader>
      </div>
    <div v-if="resultImport.length === 0">
      <ba-search-card legend="Import CSV" style="margin-top:20px;">

	  <div class="tooltip-container">
		   <div class="filter-link">
			<a v-bind:href="handleGetFileExemple(3)">
			  <ab-icon icon="excel"></ab-icon>
			  <div class="txt_logo_excel">
				Mise à jour du stock.csv
			  </div>
			</a>
		  </div>
	  </div>

       <form @submit.prevent="uploadFile" style="margin: 20px;" enctype="multipart/form-data">
                <file-pond
                  name="test"
                  ref="pond"
                  :label-idle="attachedFile.pondLabel"
                  :allow-multiple="false"
                  :max-file-size="attachedFile.maxFileSizeTrunc"
                  :label-file-type-not-allowed="'Fichier invalide'"
                  :file-validate-type-label-expected-types="''"
                  :label-max-file-size-exceeded="'Le fichier est trop lourd'"
                  :label-max-file-size="`La taille d'un fichier doit être de ${attachedFile.maxFileSizeTrunc} maximum`"
                  :allow-file-type-validation="true"
                  :fileValidateTypeDetectType="getCustomMIMEType"
                  accepted-file-types="text/csv">
                </file-pond>
                 <div class="buttons-container flex flex-end">
                <ba-button class="primary" :disabled="stateBTImport">Importer</ba-button>
              </div>
       </form>
      </ba-search-card>
	  <br/>
	  <br/>
	</div>
	<div v-else class="buttons-container flex flex-end">
		<ba-button class="primary" v-if="this.resultImport.length !== 0" @click.native="reimporter()">Réimporter</ba-button>
		<ba-button class="primary" @click.native="close()">Fermer</ba-button>
	</div>

	<div v-if="affichRecap === true">
		<div v-if="nbrTot !== 0 && nbrTot !== ''" class="recapPart">Nombre total de pièces : <b>{{ nbrTot }}</b></div>
		<div class="recapPart"><br/>Nombre de pièces importées : <b>{{ statImport[0].insert }}</b></div>
		<div class="recapPart"><br/>Nombre de pièces mises à jour : <b>{{ statImport[0].updat }}</b></div>
		<div v-if="this.resultImport.length !== 0 && this.resultImport.length !== ''" class="recapPart"><br/>Nombre de pièces en erreur : <b>{{ this.resultImport.length }}</b></div>

		<br/>

		<ba-checkbox v-model="chkboxMrq" v-if="resultImport.length != 0">Marque ({{ nbrErrorMrq }})</ba-checkbox>
		<ba-checkbox v-model="chkboxModel" v-if="resultImport.length != 0">Modèle ({{ nbrErrorModel }})</ba-checkbox>
		<ba-checkbox v-model="chkboxPrix" v-if="resultImport.length != 0">Prix ({{ nbrErrorPrix }})</ba-checkbox>
		<ba-checkbox v-model="chkboxTypePart" v-if="resultImport.length != 0">Type de pièce ({{ nbrErrorTypePart }})</ba-checkbox>
	</div>

	<br/>
	<br/>
      <ba-table v-if="resultImport.length && !loading">
        <template slot="colgroup">
		  <col width="0%">
          <col width="15%">
          <col width="15%">
          <col width="25%">
          <col width="15%">
          <col width="15%">
          <col width="15%">
          <col>
        </template>
        <template slot="body">
          <tr v-for="(ligne, index) in resultImport" v-if="(resultImport[index][0].affiLigne === true)" :key="index" v-bind:class="ligne[0]._classError">
            <td v-if="(ligne[0]._classError === 'tr-noAllowed_a' || ligne[0]._classError === 'tr-noAllowed_b')"  class="tooltip-container">
			  <ab-icon class="cursor-pointer mr14" icon="info"></ab-icon>
              <div class="tooltip tooltipLeft" >
                <pre v-if="ligne[0]._classError === 'tr-noAllowed_a'">Cette pièce n'appartient pas à votre compagnie</pre>
                <pre v-if="ligne[0]._classError === 'tr-noAllowed_b'">Cette pièce est vendue</pre>
              </div>
            </td>
            <td v-else>
            </td>
			<!-- sku -->
            <td class="noError">{{ ligne[0].value }}</td>
			<!-- marque -->
			<td v-if="ligne[1].valid === true" class="noError">{{ ligne[1].value }}</td>
			<td v-else v-bind:class="ligne[1]._classError">
				<span v-if="ligne[1]._classError !== false" class="textBarre">{{ ligne[1].value }}</span>
				<span v-else class="noError">&nbsp;</span>
				<ba-select
					class=""
					label=""
					:allow-empty="false"
					:disabled="false"
					v-model="resultImport[index][1].value"
					@change="selectedOption(index, 1)">
					<option v-for="(obj, index1) in ligne[1].validOption" :value="obj.name" :key="index1">{{ obj.name }}</option>
				</ba-select>
			</td>

			<!-- model -->
			<td v-if="ligne[2].valid === true" class="noError">{{ ligne[2].value }}</td>
			<td v-else v-bind:class="ligne[2]._classError">
				<span v-if="ligne[2]._classError !== false" class="textBarre">{{ ligne[2].value }}</span>
				<span v-else class="noError">&nbsp;</span>
				<ba-select
					class=""
					label=""
					:allow-empty="false"
					:disabled="false"
					v-model="resultImport[index][2].value"
					@change="selectedOption(index, 2)">
					<option v-for="(obj, index2) in ligne[2].validOption"  :key="index2">{{ obj.name }}</option>
				</ba-select>
			</td>

			<!-- prix -->
			<td v-if="ligne[5].valid === true" class="noError">{{ ligne[5].value | currency }}</td>
			<td v-else v-bind:class="ligne[5]._classError">
				<span v-if="ligne[5]._classError !== false" class="textBarre">{{ ligne[5].value | currency }}</span>
				<span v-else class="noError">&nbsp;</span>
				<ba-input type="text" v-model="resultImport[index][5].value" @change="updatedPrice(index, 5)"></ba-input>
			</td>

			<!-- type de piece -->
			<td v-if="ligne[3].valid === true" class="noError">{{ getLibelleTypeModele(ligne[3].value) | capitalize }}</td>
			<td v-else v-bind:class="ligne[3]._classError">
				<span v-if="ligne[3]._classError !== false" class="textBarre">{{ ligne[3].value }}</span>
				<span v-else class="noError">&nbsp;</span>
				<ba-select
					class=""
					label=""
					:allow-empty="false"
					:disabled="false"
					v-model="resultImport[index][3].value"
					@change="selectedOption(index, 3)">
					<option v-for="(obj, index2) in ligne[3].validOption" :key="index2">{{ obj.name }}</option>
				</ba-select>
			</td>

			<!-- reference -->
            <td class="noError">{{ ligne[4].value }}</td>
            <td class="more filter-link flex flex-end noError">
			  <div class="tooltip-container">
				  <span class="item" @click="deleteLigne(index)"><ab-icon icon="delete" class="delete" iconset="documentgeneral"></ab-icon></span>
				  <div class="tooltip">
                      {{ $t('action.cancel') }}
                  </div>
			  </div>
            </td>
          </tr>
        </template>
        <template slot="head">
          <tr>
            <th v-for="(col, index) in cols" :key="index">
              <span>{{ col.label }}</span>
            </th>
          </tr>
        </template>
      </ba-table>

		<ab-iconset iconset="documentgeneral">
		  <g id="delete">
			<path d="M19.875 3H15.75V2.25C15.75 1.00936 14.7406 0 13.5 0H10.5C9.25936 0 8.25 1.00936 8.25 2.25V3H4.125C3.09113 3 2.25 3.84113 2.25 4.875V7.5C2.25 7.91419 2.58581 8.25 3 8.25H3.40988L4.05783 21.857C4.11506 23.0587 5.10225 24 6.30525 24H17.6947C18.8978 24 19.885 23.0587 19.9422 21.857L20.5901 8.25H21C21.4142 8.25 21.75 7.91419 21.75 7.5V4.875C21.75 3.84113 20.9089 3 19.875 3ZM9.75 2.25C9.75 1.83647 10.0865 1.5 10.5 1.5H13.5C13.9135 1.5 14.25 1.83647 14.25 2.25V3H9.75V2.25ZM3.75 4.875C3.75 4.66823 3.91823 4.5 4.125 4.5H19.875C20.0818 4.5 20.25 4.66823 20.25 4.875V6.75C20.0189 6.75 4.7078 6.75 3.75 6.75V4.875ZM18.4439 21.7857C18.4248 22.1862 18.0957 22.5 17.6947 22.5H6.30525C5.90423 22.5 5.57517 22.1862 5.55614 21.7857L4.91156 8.25H19.0884L18.4439 21.7857Z" />
			<path d="M12 21C12.4142 21 12.75 20.6642 12.75 20.25V10.5C12.75 10.0858 12.4142 9.75 12 9.75C11.5858 9.75 11.25 10.0858 11.25 10.5V20.25C11.25 20.6642 11.5858 21 12 21Z" />
			<path d="M15.75 21C16.1642 21 16.5 20.6642 16.5 20.25V10.5C16.5 10.0858 16.1642 9.75 15.75 9.75C15.3358 9.75 15 10.0858 15 10.5V20.25C15 20.6642 15.3358 21 15.75 21Z" />
			<path d="M8.25 21C8.66419 21 9 20.6642 9 20.25V10.5C9 10.0858 8.66419 9.75 8.25 9.75C7.83581 9.75 7.5 10.0858 7.5 10.5V20.25C7.5 20.6642 7.83577 21 8.25 21Z" />
		  </g>
		  <g id="unValidate">
			<path d="M17.6484 5.64844H6.35153C2.84926 5.64844 0 8.49779 0 12C0 15.5022 2.84926 18.3516 6.35153 18.3516H17.6484C21.1507 18.3516 24 15.5023 24 12C24 8.49774 21.1507 5.64844 17.6484 5.64844ZM6.35153 16.9454C3.62466 16.9454 1.40625 14.7269 1.40625 12C1.40625 9.27315 3.62466 7.05469 6.35153 7.05469C9.07839 7.05469 11.2969 9.27315 11.2969 12C11.2969 14.7269 9.07839 16.9454 6.35153 16.9454Z" />
		  </g>
		  <g id="validate">
			<path d="M17.6484 5.64844H6.35156C2.8493 5.64844 0 8.49773 0 12C0 15.5023 2.8493 18.3516 6.35156 18.3516H17.6484C21.1507 18.3516 24 15.5023 24 12C24 8.49773 21.1507 5.64844 17.6484 5.64844ZM17.6484 16.9453C14.9216 16.9453 12.7031 14.7269 12.7031 12C12.7031 9.27319 14.9216 7.05469 17.6484 7.05469C20.3753 7.05469 22.5938 9.27319 22.5938 12C22.5938 14.7269 20.3753 16.9453 17.6484 16.9453Z" />
		  </g>
		</ab-iconset>
	</div>

</template>

<script>
import { mapState } from 'vuex';
import { AbIcon, AbIconset, BaButton, BaCard, BaDropdown, BaInput, BaSearch, BaSearchCard, BaSelect, BaStateLabel, BaTable, BaCheckbox} from '@ab/basic-components';

import MoLoader from '@/components/loader/mo-loader.vue';
import vueFilePond from 'vue-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

const FilePond = vueFilePond(FilePondPluginFileValidateSize, FilePondPluginFileValidateType);

import paginationMixin from '@/components/mixins/pagination.js';
import requestMixin from '@/components/mixins/request.js';
import searchMixin from '@/components/mixins/search.js';
import sortableMixin from '@/components/mixins/sortable.js';
import { generateSearchWatcher } from '@/assets/js/helpers.js';
import { fr } from 'vuejs-datepicker/dist/locale';
import Datepicker from 'vuejs-datepicker';

export default {
  name: 'DocumentList-importcsv',
  components: {
    AbIcon,
	AbIconset,
    BaButton,
    BaCard,
    BaDropdown,
    BaInput,
    BaSearch,
    BaSearchCard,
    BaSelect,
    BaStateLabel,
    BaTable,
    FilePond,
    MoLoader,
	Datepicker,
	BaCheckbox,
  },
  async mounted() {
      this.initInterface();
	  this.typePart = await this.$store.dispatch('getAllTypePiece');
  },
  data() {
    return {
      loadingUploadFile:false,
      loadingPopupValidation:false,
      loading: false,
	  stateBTImport:true,
      stateBTValidation:true,
      stateImport:null,
	  stateFicheArticle:'general',
      userRole: this.$store.getters.getUserRole,
      result: null,
	  detailPart: '',
      isFileUploadOngoing: false,
      infoFile:null,
      attachedFile: {
        fileId: null,
        fileStatus: '',
        maxFileSize: 10000000,
        maxFileSizeTrunc: '10 MB',
        pondLabel: "Glissez votre fichier CSV ou <u>cliquez ici</u>",
        pondAcceptedFileType: [ 'application/vnd.ms-excel','text/csv'],
        currentPage: 1,
        searchLimit: 5,
        resultatImport:null,
		allBrands: null,
      },
      statImport: [{
		insert: 0,
		updat: 0
      }],
      cols: [
        { label: '', sortable: false },
        { label: 'SKU', sortable: false },
        { label: 'Marque', sortable: false },
        { label: 'Model', sortable: false },
        { label: 'Prix', sortable: false },
		{ label: 'Type de pièce', sortable: false },
		{ label: 'Référence', sortable: false },
		{ label: '', sortable: false },
      ],
	  fr: fr,
	  typePart: [],
	  nbrTot: '',
	  affichRecap: false,
	  nbrErrorMrq: 0,
	  nbrErrorModel: 0,
	  nbrErrorPrix: 0,
	  nbrErrorTypePart: 0,
	  chkboxMrq: true,
	  chkboxModel: true,
	  chkboxPrix: true,
	  chkboxTypePart: true,
    };
  },
  computed: {
	...mapState({ resultImport: state => state.parts.uploadPartsCsv }),
	...mapState({ allBrands: state => state.parts.brands }),
  },
  watch: {
	chkboxMrq:function() {
		this.filtreError()
	},
	chkboxModel:function() {
		this.filtreError()
	},
	chkboxTypePart:function() {
		this.filtreError()
	},
	chkboxPrix:function() {
		this.filtreError()
	},
	resultImport:function() {
		this.affichRecap = true
		this.nbrErrorMrq = 0
		for (const lig of this.resultImport) {
		  this.nbrErrorMrq = lig[1].valid === false ? this.nbrErrorMrq + 1 : this.nbrErrorMrq;
		}
		this.nbrErrorModel = 0
		for (const lig of this.resultImport) {
		  this.nbrErrorModel = lig[2].valid === false ? this.nbrErrorModel + 1 : this.nbrErrorModel;
		}
		this.nbrErrorPrix = 0
		for (const lig of this.resultImport) {
		  this.nbrErrorPrix = lig[5].valid === false ? this.nbrErrorPrix + 1 : this.nbrErrorPrix;
		}
		this.nbrErrorTypePart = 0
		for (const lig of this.resultImport) {
		  this.nbrErrorTypePart = lig[3].valid === false ? this.nbrErrorTypePart + 1 : this.nbrErrorTypePart;
		}
	}
  },
  methods: {
	  filtreError() {
  		// 1 => marque
		// 2 => model
		// 3 => type piece
		// 5 => prix

		for (let i = 0; i < this.resultImport.length; i++) {
			let flagAff = false
			if(this.chkboxMrq === true && this.resultImport[i][1].valid === false) {
				flagAff = true
			}

			if(flagAff === false) {
				if(this.chkboxModel === true && this.resultImport[i][2].valid === false) {
					flagAff = true
				}
			}

			if(flagAff === false) {
				if(this.chkboxPrix === true && this.resultImport[i][5].valid === false) {
					flagAff = true
				}
			}

			if(flagAff === false) {
				if(this.chkboxTypePart === true && this.resultImport[i][3].valid === false) {
					flagAff = true
				}
			}

			if(flagAff === true) {
				this.resultImport[i][0].affiLigne = true
			} else {
				this.resultImport[i][0].affiLigne = false
			}
		}
	  },
	  async close() {
		await this.$store.dispatch('clearPartsCsv', {data: []});
		this.nbrTot = ''
		this.nbrErrorMrq = 0
		this.nbrErrorModel = 0
		this.nbrErrorPrix = 0
		this.nbrErrorTypePart = 0
		this.chkboxMrq = true
		this.chkboxModel = true
		this.chkboxPrix = true
		this.chkboxTypePart = true
		this.statImport = [{insert: 0, updat: 0}],
		await this.$store.dispatch('clearPartsCsv', {data: []});
		this.affichRecap = false
	  },
	  async deleteLigne(index) {
		this.$store.dispatch('deleteLineUploadPartsCsv', {data:index})

		if(this.resultImport.length === 0) {
			this.nbrTot = ''
			this.statImport = [{insert: 0, updat: 0}],
			await this.$store.dispatch('clearPartsCsv', {data: []});
			this.affichRecap = false
		}
	  },
	  async reimporter() {
		this.$store.commit('setSpinner', true);
		let partOfArrayLines = []
		let enre = ''
		this.nbrTot = 0
        for(const y of this.resultImport) {
			enre = ''
			for(let i=0; i < y.length; i++) {
				if(i !== 19) {
					enre = enre + y[i].value + ';'
				} else {
					enre = enre + y[i].value
					this.nbrTot++
					partOfArrayLines.push(enre)
				}
			}
		}
		await this.$store.dispatch('clearPartsCsv', {data: []});
		this.statImport = await this.$store.dispatch('uploadPartsCsv', {data: partOfArrayLines})
		partOfArrayLines = []
		this.$store.commit('setSpinner', false);
	  },
	  getLibelleTypeModele(id) {
		for (let i = 0; i < this.typePart.length; i++) {
			if(parseInt(id) === this.typePart[i].id) {
				return (this.typePart[i].name)
			}
		}
	  },
	  // le selecteur à ete modifié
	  // on va mettre à jour le store -> class
	  // et considerer dans un permier temps que
	  // la valeur est correcte
	  async selectedOption(x,y) {
		this.resultImport[x][y]._classError = false
		// si on a modifie la marque alors on recharge les modele
		if(y === 1) {
			// on va recuperer l'id de la marque
			let idMarque = ''
			for (let z = 0; z < this.resultImport[x][1].validOption.length; z++) {
				if(this.resultImport[x][1].validOption[z].name === this.resultImport[x][1].value) {
					idMarque = this.resultImport[x][1].validOption[z].id
				}
			}
			// recup des modeles en json
			let validOption = []
			const model_tmp_json = await this.$store.dispatch('getModels', idMarque)
			// on va réalimenter le store pour rester coherent
			for (let y = 0; y < model_tmp_json.length; y++) {
				validOption.push({id: model_tmp_json[y].id, name: model_tmp_json[y].name})
			}
			this.resultImport[x][2].validOption = validOption
		}
		if(y === 2) {
			this.resultImport[x][2]._classError = false
		}

	  },
	  updatedPrice(x,y) {
		// verif
		const reg = new RegExp('^[1-9][0-9]{0,2}(?:,?[0-9]{3}){0,3}\.[0-9]{0,2}$')

		const count1 = this.resultImport[x][y].value.split(',').length - 1;
		const count2 = this.resultImport[x][y].value.split(',').length - 1;
		if((count1 + count2) > 1) {
			return false
		}

		if(reg.test(this.resultImport[x][y].value)) {
			this.resultImport[x][y]._classError = false
			return true
		}
		return false
	  },
      async initInterface() {
        this.stateBTImport = false;
        this.loading = false;
      },
      getCustomMIMEType: function getCustomMIMEType(source, type) {
		this.affichRecap = false
		if (window.navigator.platform.indexOf('Win') > -1) {
			if (type === 'application/vnd.ms-excel') type = 'text/csv'
		}
      return Promise.resolve(type)
    },
    async uploadFile() {
        if(!this.stateBTImport) {

            // Check if file has been selected
            if (!this.$refs.pond.getFile()) {
              return this.$store.dispatch('displaySnackbar', { text: `Veuillez ajouter un document`, mode: 'error' });
            }

            // Check file type
            const fileType = this.attachedFile.pondAcceptedFileType.find(e => e == this.$refs.pond.getFile().file.type);

            if (typeof fileType == 'undefined') {
              return this.$store.dispatch('displaySnackbar', { text: `Veuillez sélectionner fichier CSV valide`, mode: 'error' });
            }

			////////////////////////////////////////////////////////////////////////////////////////////////////
			// Filepond parsing to string
			////////////////////////////////////////////////////////////////////////////////////////////////////

			this.$store.commit('setSpinner', true);
			await this.$store.dispatch('clearPartsCsv', {data: []});

			// Récupération du fichier (type 'File': https://developer.mozilla.org/fr/docs/Web/API/File
			// 'File' hérite du type 'Blob' (https://developer.mozilla.org/fr/docs/Web/API/Blob) qui contient la méthode text renvoi une Promesse<String>

			let file = this.$refs.pond.getFile().file;
			let fileText = await file.text();
			fileText += '\r\n';

			const searchStr = ';';
			const indexes = [...fileText.matchAll(new RegExp(searchStr, 'gi'))].map(a => a.index);

            // le fichier semble il correcte
			if((indexes.length % 19) !== 0) {
				this.$store.dispatch('displaySnackbar', { text: `Le fichier d'import est mal formaté`, mode: 'error' });
				this.$store.commit('setSpinner', false);
				return
			}

			// on calcul le nombre total d'enregistrements à traiter
			this.nbrTot = (indexes.length / 19) - 1
			if(this.nbrTot > 500) {
				this.nbrTot = ''
				this.$store.dispatch('displaySnackbar', { text: `L'import manuel est limité à 500 pièces, veuillez passer par le système API`, mode: 'error' });
				this.$store.commit('setSpinner', false);
				return;
			}
			////////////////////////////////////////////////////////////////////////////////
			//                                                                            //
			// parse du fichier csv et envoie des enregistrements 10 par 10 (option cpt2) //
			//                                                                            //
			////////////////////////////////////////////////////////////////////////////////

			let partOfArrayLines = []
			let cpt1 = 0
		//	let cpt2 = 0
			let fileTextTmp = ''
			let enre  = ''
			let posDebLig = 0
			let posFinLig = 0
			let flag = 0

			for (let y = 0; y < indexes.length; y++) {
				cpt1++
				if(cpt1 === 19) {
			//		cpt2++
					fileTextTmp = fileText.substring(indexes[y])

					posFinLig = fileTextTmp.indexOf('\r\n');
					enre = fileText.substring(posDebLig, posFinLig)
					posFinLig = posFinLig + indexes[y]
					enre = fileText.substring(posDebLig, posFinLig)

					if (flag !== 0) {
						partOfArrayLines.push(enre)
					}
					flag++
			//		if(cpt2 === 10) {
			//			await this.$store.dispatch('uploadPartsCsv', {data: partOfArrayLines})
			//			partOfArrayLines = []
			//			cpt2 = 0
			//		}
					posDebLig = posFinLig + 2
					cpt1 = 0
				}
			}
			if(partOfArrayLines.length !== 0) {
				this.statImport = await this.$store.dispatch('uploadPartsCsv', {data: partOfArrayLines})
			}
        }
		this.$store.commit('setSpinner', false);
    },

    cancelValidation() {
        this.result = null;
        this.stateBTValidation = true;
        this.stateImport = 0;
        this.initInterface();
    },

    async uploadFileValidation() {
        if(!this.stateBTValidation) {
            this.closeModalValidation();
            this.stateImport = 2;
            this.loadingPopupValidation = true;
            this.stateBTImport = true;
            this.stateBTBackup = true;
            this.stateBTValidation = true;
                const data = await this.$store.dispatch('validationImportCsv', {
               infoFile: this.infoFile
             });
            this.resultatImport = data;
            this.stateBTImport = false;
            this.stateBTBackup = false;
            this.stateBTValidation = false;
            this.loadingPopupValidation = false;
         }
    },
    handleGetFileExemple(x) {
      const baseApi = process.env.VUE_APP_ROOT_API;
	  return `${baseApi}/public/data/` + encodeURI('Mise à jour du stock.csv')
    }
  },
	filters: {
	  capitalize: function (value) {
		if (!value) return ''
		value = value.toString()
		return value.charAt(0).toUpperCase() + value.slice(1)
	  },
	  capitalize_bis: function (value) {
		if (!value) return ''
		value = value.toString()
		let words = value.split(' ')
		words = words.map(x => x.charAt(0).toUpperCase() + x.slice(1))
		return words.join(' ')
	  },
	  formatPrice: function (value) {
		if (!value) return ''
		let nombre = new Intl.NumberFormat().format(value)
		let isDec = nombre.indexOf(',')
		if (isDec != -1) {
			let decimal = nombre.substring(isDec + 1)
			if( decimal.length === 1 ) {
				nombre = nombre + 0
			}
		}
		return nombre
	  }
	},
};
</script>

<style>
.positionIcon {
  position:absolute;
  top:60px;
  right:50px;
}

.tooltip-container {
  display: flex;
}

.tooltipLeft {
  padding-left: 70px;
}

.filter-link {
  padding-left: 24px;
}

.txt_logo_excel {
  padding-top: 4px;
  float:right;
  font-weight: 400;
  line-height: 1.5;
  color: #4f4f4f;
}

/*
.tr-background {
  background-color: #ff0000;
}
*/
.tdFalse {
  color: #ff0000;
}

.noError {
  padding-top: 39px!important;
}

.textBarre{
  font-size: 11px;
}

.ba-table tbody tr:nth-child(2n) {
  background-color: var(--basic-table-rows-bg-color, #E1EEFF);
}

.recapPart{
/*  font-weight: bold; */
}

.tr-noAllowed_a{
  background-color: #fe526c !important;
}

.tr-noAllowed_b{
  background-color: #fe526c !important;
}

.checkbox-label span::before {
  margin-right: 10px !important;
}
</style>

<style src="@/assets/styles/filepond.css"></style>